import { Moon, Sun } from "lucide-react";
import * as React from "react";
import { Button } from "@/components/ui/button";
import { useTheme } from "@/components/theme-provider";

/**
 * One-click theme toggle for the top navigation bar.
 * Toggles directly between dark and light themes.
 */
export function QuickThemeToggle() {
  const { theme, setTheme } = useTheme();

  const isDark =
    theme === "dark" ||
    (theme === "system" &&
      typeof window !== "undefined" &&
      window.matchMedia?.("(prefers-color-scheme: dark)").matches) ||
    (typeof document !== "undefined" && document.documentElement.classList.contains("dark"));

  const handleToggle = () => {
    const currentlyDark = document.documentElement.classList.contains("dark");
    setTheme(currentlyDark ? "light" : "dark");
  };

  return (
    <Button
      variant="ghost"
      size="icon"
      className="size-11 rounded-lg text-muted-foreground hover:text-foreground md:size-8"
      aria-label="Toggle theme"
      onClick={handleToggle}
    >
      {isDark ? <Sun className="size-4" aria-hidden /> : <Moon className="size-4" aria-hidden />}
    </Button>
  );
}
